<template>
  <v-card :loading="loading">
    <v-card-title class="grey--text text-subtitle-1">
      <v-icon color="grey" class="mr-2">mdi-printer</v-icon>
      Stampa
      <v-spacer></v-spacer>
      <v-btn
        small
        text
        color="grey"
        class="mr-1"
        @click="$refs.print_jobs_dialog.open()"
      >
        <v-icon small left>mdi-format-list-bulleted</v-icon>
        Storico Jobs
      </v-btn>
      <v-btn icon :loading="loading" @click="fetch">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>

      <!-- Infobox stampanti -->
      <div class="grey--text text-caption mb-2">
        Stampanti — clicca per selezionare
      </div>
      <v-row no-gutters align="center" class="mb-4">
        <v-col
          v-for="stampante in stampanti"
          :key="stampante.id"
          cols="auto"
          class="mr-2 mb-1"
        >
          <v-chip
            label
            :color="stampante.status === 'online' ? 'green' : 'red'"
            :dark="device_sel === stampante.device_id"
            :outlined="device_sel !== stampante.device_id"
            :disabled="stampante.status !== 'online'"
            style="cursor: pointer"
            @click="device_sel = stampante.device_id"
          >
            <v-icon small left>mdi-printer</v-icon>
            {{ stampante.device_id }}
            <span class="ml-2 font-weight-light">{{
              stampante.status === "online" ? "Online" : "Offline"
            }}</span>
            <v-icon
              small
              class="ml-2"
              @click.stop="$refs.config_stampante_dialog.open(stampante)"
              >mdi-cog</v-icon
            >
          </v-chip>
        </v-col>
        <v-col
          v-if="!loading && stampanti.length === 0"
          cols="12"
          class="grey--text text-caption"
        >
          Nessuna stampante disponibile
        </v-col>
      </v-row>

      <v-divider class="mb-5" />

      <v-row>
        <!-- COLONNA SX: prodotto + lista varietà per produttore -->
        <v-col cols="8">
          <v-autocomplete
            v-model="prodotto_sel"
            :items="prodotti"
            label="Prodotto"
            item-text="nome"
            item-value="id"
            outlined
            hide-details
            return-object
            @change="onProdottoChange"
          >
            <template v-slot:selection="data">
              <v-list-item-avatar size="22">
                <v-img :src="avatar_img(data.item.id)" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-body-2">{{
                  nome_split(data.item.nome)[0]
                }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:item="data">
              <v-list-item-avatar>
                <img :src="avatar_img(data.item.id)" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{
                  nome_split(data.item.nome)[0]
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  nome_split(data.item.nome)[1]
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>

          <template v-if="prodotto_sel">
            <v-progress-linear
              v-if="colori_loading"
              indeterminate
              class="mt-3"
            />
            <div
              v-else
              style="max-height: 500px; overflow-y: auto"
              class="mt-3"
            >
              <div v-for="gruppo in varieta_sort" :key="gruppo.id_produttore">
                <v-divider />
                <v-row
                  align="center"
                  no-gutters
                  class="py-2 px-2"
                  style="cursor: pointer"
                  @click="toggleFornitore(gruppo.id_produttore)"
                >
                  <v-avatar size="28" class="mr-2">
                    <v-img :src="avatar_fornit(gruppo.id_produttore)" />
                  </v-avatar>
                  <span class="green--text font-weight-light">{{
                    nome_fornit(gruppo.id_produttore)
                  }}</span>
                  <v-spacer />
                  <v-icon small color="green">
                    {{ collapsed_fornitori[gruppo.id_produttore] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </v-icon>
                </v-row>
                <v-expand-transition>
                  <div v-show="collapsed_fornitori[gruppo.id_produttore]">
                    <div
                      v-for="sg in gruppo.serie_groups"
                      :key="sg.id_serie || '__none__'"
                    >
                      <v-row no-gutters align="center" class="py-1 px-4 mt-1">
                        <span class="text-caption blue-grey--text font-weight-medium">
                          {{ sg.id_serie ? serieOf(sg.id_serie) : 'Senza serie' }}
                        </span>
                        <v-divider class="ml-2" />
                      </v-row>
                      <v-hover
                        v-for="varieta in sg.varieta"
                        :key="varieta.id"
                        v-slot="{ hover }"
                      >
                        <v-row
                          no-gutters
                          align="center"
                          class="py-2 px-2"
                          :class="
                            varieta_sel_id === varieta.id
                              ? 'green lighten-5'
                              : hover
                              ? 'grey lighten-4'
                              : ''
                          "
                          style="cursor: pointer"
                          @click="varieta_sel_id = varieta.id"
                        >
                          <v-col cols="auto" class="mr-3">
                            <v-avatar size="46">
                              <v-img :src="avatar_colore(varieta)" />
                            </v-avatar>
                          </v-col>
                          <v-col cols="3">
                            <div class="text-caption grey--text">
                              {{ sg.id_serie ? serieOf(sg.id_serie) : '' }}
                            </div>
                            <div class="text-body-1">{{ varieta.nome }}</div>
                          </v-col>
                          <v-col cols="6">
                            {{ coloreOf(varieta.id_colore) }}
                          </v-col>
                          <v-col cols="2">
                            <v-icon v-if="varieta_sel_id === varieta.id" color="green"
                              >mdi-check</v-icon
                            >
                          </v-col>
                        </v-row>
                      </v-hover>
                    </div>
                  </div>
                </v-expand-transition>
              </div>
              <v-row v-if="varieta_sort.length === 0" no-gutters class="mt-2">
                <v-col class="grey--text text-caption"
                  >Nessuna varietà disponibile</v-col
                >
              </v-row>
            </div>
          </template>
        </v-col>

        <!-- COLONNA DX: lotto, torba, posizione -->
        <v-col cols="4">
          <v-autocomplete
            v-model="lotto_sel"
            :items="lotti_filtrati"
            label="Lotto"
            item-text="codice"
            item-value="id"
            outlined
            hide-details
            return-object
            class="mb-4"
          >
            <template v-slot:selection="data">
              <v-list-item-avatar size="22">
                <img :src="avatar_fornit(data.item.id_fornitore)" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-body-2">{{
                  data.item.codice
                }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:item="data">
              <v-list-item-avatar>
                <img :src="avatar_fornit(data.item.id_fornitore)" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ data.item.codice }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  nome_fornit(data.item.id_fornitore)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>

          <v-autocomplete
            v-model="torba_sel"
            :items="torbe"
            label="Torba"
            item-text="nome"
            item-value="id"
            outlined
            hide-details
            return-object
            class="mb-4"
          />

          <v-select
            v-model="zone_sel"
            :items="zone_coltivazione"
            label="Posizione"
            item-text="nome"
            item-value="id"
            outlined
            hide-details
            multiple
            chips
            small-chips
            class="mb-4"
          >
            <template v-slot:prepend-inner>
              <v-icon small class="mt-1">mdi-greenhouse</v-icon>
            </template>
          </v-select>
          <v-row no-gutters align="center">
            <v-col cols="4">
              <v-text-field
                v-model.number="qta"
                label="Quantità"
                type="number"
                min="1"
                outlined
                hide-details
                class="mb-6"
                :disabled="op_mode === 1"
              />
            </v-col>
            <v-col cols="8">
              <v-select
                v-model="op_mode"
                :items="op_mode_options"
                label="Modalità"
                item-text="text"
                item-value="value"
                outlined
                hide-details
                class="mb-6 ml-4"
              />
            </v-col>
          </v-row>

          <v-row no-gutters align="center">
            <v-btn
              outlined
              x-large
              color="green"
              :loading="submitting"
              :disabled="!canSubmit"
              @click="invia"
            >
              <v-icon left>mdi-printer</v-icon>Stampa
            </v-btn>
            <v-expand-x-transition>
              <v-icon class="ml-3" color="success" v-if="print_ok"
                >mdi-check</v-icon
              >
            </v-expand-x-transition>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>

    <PrintJobsDialog ref="print_jobs_dialog" />
    <ConfigStampanteDialog ref="config_stampante_dialog" />

    <v-snackbar
      v-model="error_snackbar"
      color="red darken-1"
      bottom
      right
      timeout="5000"
    >
      <v-icon small class="mr-2">mdi-alert-circle</v-icon>
      Stampa non riuscita — agente di stampa non raggiungibile
    </v-snackbar>

    <v-snackbar
      v-model="assoc_snackbar"
      :color="assoc_created ? 'green darken-1' : 'blue-grey'"
      bottom
      right
      timeout="3000"
    >
      <v-icon small class="mr-2">{{ assoc_created ? 'mdi-link-variant-plus' : 'mdi-link-variant' }}</v-icon>
      {{ assoc_created ? 'Nuovo collegamento lotto–prodotto creato' : 'Lotto già collegato al prodotto' }}
    </v-snackbar>
  </v-card>
</template>

<script>
import PrintJobsDialog from "./print_jobs_dialog.vue";
import ConfigStampanteDialog from "./config_stampante_dialog.vue";
export default {
  name: "StampaDesktop",
  components: { PrintJobsDialog, ConfigStampanteDialog },
  data: () => ({
    loading: false,
    submitting: false,
    print_ok: false,
    device_sel: null,
    prodotto_sel: null,
    colori: [],
    colori_loading: false,
    varieta_sel_id: null,
    lotto_sel: null,
    torba_sel: null,
    zone_sel: [],
    qta: 9999,
    collapsed_fornitori: {},
    error_snackbar: false,
    assoc_snackbar: false,
    assoc_created: false,
    op_mode: 1,
    op_mode_options: [
      { text: "Applica", value: 1 },
      { text: "Riavvolgi", value: 2 },
      { text: "Manuale", value: 3 },
    ],
  }),
  mounted() {
    this.fetch().then(() => this.preloadFromQuery());
  },
  watch: {
    op_mode(val) {
      this.qta = val === 1 ? 9999 : 1;
    },
    varieta_sel_id() {
      this.lotto_sel = this.lotti_filtrati[0] || null;
    },
  },
  computed: {
    stampanti() {
      return this.$store.getters.get_stampanti;
    },
    stampante_sel() {
      return (
        this.stampanti.find((s) => s.device_id === this.device_sel) || null
      );
    },
    prodotti() {
      return this.$store.getters.get_lista_prodotti_raw;
    },
    specie() {
      if (!this.prodotto_sel) return null;
      return this.$store.getters.get_specie_by_id(this.prodotto_sel.specie);
    },
    varieta_sort() {
      if (!this.specie || !this.specie.variety) return [];
      const byFornitore = this.specie.variety.reduce((acc, v) => {
        if (!acc[v.id_produttore]) acc[v.id_produttore] = {};
        const serie_key = String(v.serie ?? "__none__");
        if (!acc[v.id_produttore][serie_key]) acc[v.id_produttore][serie_key] = [];
        acc[v.id_produttore][serie_key].push(v);
        return acc;
      }, {});
      return Object.keys(byFornitore).map((id_produttore) => ({
        id_produttore,
        serie_groups: Object.keys(byFornitore[id_produttore]).map((serie_key) => ({
          id_serie: serie_key === "__none__" ? null : serie_key,
          varieta: byFornitore[id_produttore][serie_key],
        })),
      }));
    },
    varieta_sel() {
      if (!this.specie || !this.varieta_sel_id) return null;
      return this.specie.variety.find((v) => v.id === this.varieta_sel_id);
    },
    serie_sel() {
      if (!this.specie || !this.varieta_sel) return null;
      return (
        this.specie.series.find((s) => s.id == this.varieta_sel.serie) || null
      );
    },
    lotti_filtrati() {
      const lotti = this.$store.getters.get_lotti;
      if (!this.varieta_sel)
        return lotti.slice().sort((a, b) => b.ts_documento - a.ts_documento);
      return lotti
        .filter((l) => l.id_fornitore == this.varieta_sel.id_produttore)
        .sort((a, b) => b.ts_documento - a.ts_documento);
    },
    torbe() {
      return this.$store.getters.get_torbe;
    },
    zone_coltivazione() {
      return this.$store.getters.get_zone_coltivazione;
    },
    effective_print_param() {
      const base = {
        mode: this.stampante_sel?.mode ?? "R",
        velocity: this.stampante_sel?.velocity ?? 4,
        darkness: this.stampante_sel?.darkness ?? 4,
        orientation: this.stampante_sel?.orientation ?? "I",
        offset_x: this.stampante_sel?.offset_x ?? 0,
        offset_y: this.stampante_sel?.offset_y ?? 0,
      };
      if (this.op_mode === 1) return { ...base, mode: "P", orientation: "I" };
      if (this.op_mode === 2) return { ...base, mode: "R", orientation: "N" };
      return base;
    },
    canSubmit() {
      return (
        this.device_sel &&
        this.prodotto_sel &&
        this.varieta_sel &&
        this.lotto_sel &&
        this.torba_sel &&
        this.qta > 0
      );
    },
  },
  methods: {
    fetch() {
      this.loading = true;
      return Promise.all([
        this.$store.dispatch("fetch_stampanti"),
        this.$store.dispatch("fetch_print_jobs"),
      ]).then(() => {
        if (!this.device_sel && this.stampanti.length > 0) {
          this.device_sel = this.stampanti[0].device_id;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    async preloadFromQuery() {
      const { id_prodotto, id_varieta, id_lotto } = this.$route.query;
      if (!id_prodotto) return;
      this.prodotto_sel = this.prodotti.find((p) => p.id == id_prodotto) || null;
      if (!this.prodotto_sel) return;
      await this.onProdottoChange();
      if (id_varieta) {
        this.varieta_sel_id = id_varieta;
        await this.$nextTick();
      }
      if (id_lotto) {
        const lotto = this.$store.getters.get_lotti.find((l) => l.id == id_lotto);
        if (lotto) this.lotto_sel = lotto;
      }
    },
    onProdottoChange() {
      this.varieta_sel_id = null;
      this.lotto_sel = null;
      this.colori = [];
      this.collapsed_fornitori = {};
      if (!this.prodotto_sel || !this.specie) return Promise.resolve();
      this.colori_loading = true;
      return this.$store
        .dispatch("fetch_colori_by_id", this.specie.colori)
        .then((res) => {
          this.colori = res;
        })
        .finally(() => {
          this.colori_loading = false;
        });
    },
    toggleFornitore(id) {
      this.$set(this.collapsed_fornitori, id, !this.collapsed_fornitori[id]);
    },
    nome_split(nome) {
      return nome.split(" in ");
    },
    avatar_img(id) {
      return process.env.VUE_APP_API_ROOT + "/avatar_img/" + id;
    },
    avatar_fornit(id) {
      return process.env.VUE_APP_API_ROOT + "/fornitore/" + id + "/avatar";
    },
    avatar_colore(varieta) {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/img_colore/" +
        varieta.id_colore +
        "?t=" +
        varieta.md5_colore
      );
    },
    nome_fornit(id) {
      return this.$store.getters.get_fornitore_by_id(id).nome;
    },
    serieOf(id_serie) {
      if (!this.specie) return "";
      const s = this.specie.series.find((s) => s.id == id_serie);
      return s ? s.nome : "";
    },
    coloreOf(id_colore) {
      const c = this.colori.find((c) => c.id == id_colore);
      return c ? c.nome : "";
    },
    buildPayload() {
      return {
        protocol_version: "1.0",
        job_id: `job_${Date.now()}`,
        device_id: this.device_sel,
        print_param: this.effective_print_param,
        template: "pianta",
        label: {
          prodotto: this.nome_split(this.prodotto_sel.nome)[0].toUpperCase(),
          serie: this.serieOf(this.varieta_sel.serie),
          varieta: this.varieta_sel.nome.toUpperCase(),
          colore: this.coloreOf(this.varieta_sel.id_colore).toUpperCase(),
          lotto: this.lotto_sel.codice,
          codice_torba: this.torba_sel.cod || "",
          posizione: this.zone_sel,
          passaporto_a: this.specie ? this.specie.nome_sc : "",
          passaporto_b: "IT-01-0499",
          passaporto_c: "CN-01-" + this.lotto_sel.codice,
          qr_content: `https://gmflor.com/#/p/${this.prodotto_sel.cod}?l=${
            this.lotto_sel.codice
          }&s=${this.specie.short_id}&e=${this.serie_sel?.short_id || ""}`,
          qta: this.qta,
        },
      };
    },
    invia() {
      this.submitting = true;
      Promise.all([
        this.$store.dispatch("invia_stampa_lotto", this.buildPayload()),
        this.$store.dispatch("associa_coltura_lotto", {
          id_prodotto: this.prodotto_sel.id,
          id_lotto: this.lotto_sel.id,
          id_zone: this.zone_sel,
        }),
      ])
        .then(([, assocRes]) => {
          this.print_ok = true;
          this.assoc_created = assocRes.created;
          this.assoc_snackbar = true;
          this.fetch();
          setTimeout(() => {
            this.print_ok = false;
          }, 3000);
        })
        .catch(() => {
          this.error_snackbar = true;
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
